/**
 * Structured JSON logger shared by all server-side packages.
 *
 * Emits single-line JSON to the level-matched console method so Workers Logs
 * (and the OTLP export to Loki) can parse entries into queryable fields via
 * `| json` instead of unstructured interpolated strings.
 */
const consoleFor = {
    debug: line => console.debug(line),
    info: line => console.info(line),
    warn: line => console.warn(line),
    error: line => console.error(line),
};
export function createLogger(options) {
    const { service, env, requestId, cfRay, context } = options;
    function emit(level, message, data) {
        const entry = {
            ts: new Date().toISOString(),
            level,
            service,
            ...(env !== undefined && { env }),
            ...(requestId !== undefined && { requestId }),
            ...(cfRay !== undefined && { cfRay }),
            message,
            ...context,
            ...data,
        };
        consoleFor[level](JSON.stringify(entry));
        return entry;
    }
    return {
        requestId,
        cfRay,
        debug: (message, data) => emit('debug', message, data),
        info: (message, data) => emit('info', message, data),
        warn: (message, data) => emit('warn', message, data),
        error: (message, data) => emit('error', message, data),
        child(childContext) {
            return createLogger({ ...options, context: { ...context, ...childContext } });
        },
    };
}
export async function withTiming(fn) {
    const start = Date.now();
    try {
        const result = await fn();
        return { result, durationMs: Date.now() - start };
    }
    catch (error) {
        error.durationMs = Date.now() - start;
        throw error;
    }
}
//# sourceMappingURL=logger.js.map